import React from 'react'
import CompanyContainer from '../../containers/admin_portal/company';

const CompanyPage = () => {
  return <CompanyContainer />
}

export default CompanyPage;